import { axiosRequest } from '@/util/axios-request'

// 打卡设置列表页
export const getAttachmentLlist = data => {
  return axiosRequest({
    url: '/web/attendance/attachment_list',
    data
  })
}
// 考勤群组列表
export const getAttendanceSettingList = data => {
  return axiosRequest({
    url: '/web/attendance/attendance_setting_list',
    data
  })
}
// 获取全部群组列表
export const getAllSettingList = data => {
  return axiosRequest({
    url: '/web/attendance/all_setting_list',
    data
  })
}
// 清除底片
export const delAttchment = data => {
  return axiosRequest({
    url: '/web/attendance/del_attachment',
    data
  })
}
// 查看员工考勤规则

export const querySettingRule = data => {
  return axiosRequest({
    url: '/web/attendance/attendance_setting_info',
    data
  })
}

// 编辑群组规则
export const editSettings = data => {
  return axiosRequest({
    url: '/web/attendance/edit_setting',
    data
  })
}

// 删除考勤规则
export const delSetting = data => {
  return axiosRequest({
    url: '/web/attendance/del_setting',
    data
  })
}
// 查看考勤组详情
export const getSettingInfo = data => {
  return axiosRequest({
    url: '/web/attendance/setting_info',
    data
  })
}

// 考勤统计列表
export const getAttendance = data =>
  axiosRequest({
    url: '/web/statistics/attendance',
    data
  })

// 添加考勤组
export const addSetting = data =>
  axiosRequest({
    url: '/web/attendance/add_setting',
    data
  })

// 检查当前登录用户是否在考勤组/班次负责人范围内
export const checkSupervisor = data =>
  axiosRequest({
    url: '/web/attendance/checkSupervisor',
    data
  })

// 导出考勤统计表
export const attendanceExcel = data =>
  axiosRequest({
    url: '/web/statistics/attendanceExcel',
    data
  })

// 保存ph公休日
export const savePhday = data =>
  axiosRequest({
    url: '/web/attendance/save_ph_days',
    data
  })

// 获取ph公休日
export const getPhday = data =>
  axiosRequest({
    url: '/web/attendance/ph_days',
    data
  })

// 排班-详情
export const round_info = data =>
  axiosRequest({
    url: '/web/attendance/round_info',
    data
  })

// 排班-添加班次
export const round_add_shift = data =>
  axiosRequest({
    url: '/web/attendance/round_add_shift',
    data
  })

// 排班-周期-添加
export const round_edit_cycle = data =>
  axiosRequest({
    url: '/web/attendance/round_edit_cycle',
    data
  })

// 排班-周期-选中分组
export const round_sel_cycle_group = data =>
  axiosRequest({
    url: '/web/attendance/round_sel_cycle_group',
    data
  })

// 班次-周期-分组人员信息
export const round_group_staff_info = data =>
  axiosRequest({
    url: '/web/attendance/round_group_staff_info',
    data
  })

// 排班-周期-分组-添加人员
export const round_group_add_staff = data =>
  axiosRequest({
    url: '/web/attendance/round_group_add_staff',
    data
  })

// 班次-周期-生成日历之前的校验
export const round_group_check_staff = data =>
  axiosRequest({
    url: '/web/attendance/round_group_check_staff',
    data
  })

// 排班-导出
export const exportStaffShift = data => {
  return axiosRequest({
    url: '/web/attendance/exportStaffShift',
    data
  })
}

// 排班-批量导出、修改模板下载
export const downloadStaffShiftTpl = data => {
  return axiosRequest({
    url: '/web/attendance/downloadStaffShiftTpl',
    data
  })
}

// 排班-批量导出、修改上传excel
export const updateStaffShift = data => {
  return axiosRequest({
    url: '/web/attendance/updateStaffShift',
    data
  })
}

// 排班-给人员添加班次-按天排班
export const round_add_staff_shift = data =>
  axiosRequest({
    url: '/web/attendance/round_add_staff_shift',
    data
  })

// 排班-给人员添加班次-按周期排班
export const round_add_staff_shift_cycle = data =>
  axiosRequest({
    url: '/web/attendance/round_add_staff_shift_cycle',
    data
  })

// 排班-给人员添加班次-按周期排班
export const round_staff_info = data =>
  axiosRequest({
    url: '/web/attendance/round_staff_info',
    data
  })

// 考勤统计详情
export const attendanceDetail = data =>
  axiosRequest({
    url: '/web/statistics/attendanceDetail',
    data
  })

// 请假统计详情
export const leaveDetail = data =>
  axiosRequest({
    url: '/web/statistics/attendanceLeaveDetail',
    data
  })

// 统计加班详情
export const attendanceOvertimeDetail = data =>
  axiosRequest({
    url: '/web/statistics/attendanceOvertimeDetail',
    data
  })

// 假期列表
export const holidayList = params =>
  axiosRequest({
    url: '/web/holiday/list',
    params
  })

export const getHolidays = () =>
  axiosRequest({
    url: '/web/attendance/holidays'
  })

// 添加公共假期
export const holidayAdd = data =>
  axiosRequest({
    url: '/web/holiday/add',
    data
  })

// 编辑公共假期
export const holidayEdit = data =>
  axiosRequest({
    url: '/web/holiday/edit',
    data
  })

// 公共假期详情
export const holidayDetail = data =>
  axiosRequest({
    url: '/web/holiday/detail',
    data
  })

// 删除公共假期规则
export const holidayDelete = data =>
  axiosRequest({
    url: '/web/holiday/delete',
    data
  })

// 获取年份
export const yearList = data =>
  axiosRequest({
    url: '/web/statistics/yearList',
    data
  })

// 获取已选员工去重之后的总数
export const countStaffs = data =>
  axiosRequest({
    url: '/web/leave/countStaffs',
    data
  })
